import { backendApiKey } from '@hantera/portal-app';
import { inject } from 'vue';
import PrivateBackendApi from '@/backend';

export default function useBackend() {
  return {
    ...inject<PrivateBackendApi>(backendApiKey, <any>{})
  };
}